/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { FormControl, FormGroup } from '@angular/forms';
import { isBoolean, isString } from 'lodash-es';

export function patchForm(valueToPatch: any, formGroup: FormGroup): void {
  formGroup.patchValue(valueToPatch);

  patchNonStringValues(valueToPatch, formGroup);
}

function patchNonStringValues(valueToPatch: any, formGroup: FormGroup): void {
  Object.entries(valueToPatch).forEach(([key, value]) => {
    if (formGroup.contains(key)) patchNonStringValue(value, getControlAsFormGroup(key, formGroup));
  });
}

function patchNonStringValue(value: any, formGroup: FormGroup): void {
  if (Array.isArray(value)) {
    value.forEach((oneValue: any) => {
      if (formGroup.contains(oneValue)) formGroup.controls[oneValue].patchValue(true);
      else formGroup.setControl(oneValue, new FormControl(true));
    });
  } else if (!isString(value) && !isBoolean(value)) {
    patchNonStringValues(value, formGroup);
  }
}

function getControlAsFormGroup(key: string, formGroup: FormGroup): FormGroup {
  return <FormGroup>formGroup.controls[key];
}
